import type React from "react";

import { IconButton } from "@similarweb/ui-components";

type Props = {
    onClick: () => void;
    text?: string;
};

export const AgentKnowledgeBaseButton: React.FC<Props> = ({ onClick, text }) => {
    return (
        <IconButton
            type="flat"
            iconName="settings"
            onClick={onClick}
            data-automation="agent-knowledge-base-button"
        >
            {text}
        </IconButton>
    );
};
